import qs from 'query-string';
import type { Observable as ObservableType } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-fetch';

export interface CardCreateConfigRestResponse {
	hasCreateIssuePermission: boolean;
	hasScheduleIssuePermission: boolean;
	issueTypes: {
		successful: boolean;
		values: Array<{
			id: string;
			name: string;
			iconUrl: string;
			hierarchyLevel: number;
			subtask: boolean;
		}>;
	};
}

export function loadCardCreateConfig(
	jqlQuery: string,
): ObservableType<CardCreateConfigRestResponse> {
	const query = qs.stringify({ query: jqlQuery });
	return fetchJson$(`/rest/inline-create/1.0/context/bootstrap?${query}`);
}
